import React from "react";
import { FormControl, FormControlLabel, FormControlLabelProps, Switch } from "@mui/material";
import { SelectInputProps } from "@mui/material/Select/SelectInput";
import { withMemo } from "../withMemo";

const CustomSwitch = (props: {
    className: string;
    name: string;
    value: boolean;
    title: string;
    onChange: SelectInputProps["onChange"];
    label: string;
    labelPlacement?: FormControlLabelProps["labelPlacement"];
    sx?: any;
}) => {
    return (
        <FormControl component="fieldset" className={props.className} sx={props.sx}>
            <FormControlLabel
                control={
                    <Switch
                        color="primary"
                        name={props.name}
                        data-automation={props.name}
                        value={props.value}
                        checked={props.value}
                        title={props.title}
                        onChange={props.onChange}
                    />
                }
                label={props.label}
                labelPlacement={props.labelPlacement}
            />
        </FormControl>
    );
};

export default withMemo(CustomSwitch, ["value", "label"]);
